/**
 * Operator metadata without any React or icon imports, so the URL codec can be
 * built from it outside a component. ORDER IS LOAD-BEARING: the codec derives
 * its type dictionary from this array's order, and changing it silently breaks
 * every filter URL a user has saved.
 */
export interface EntityFilterOperatorMeta {
  value: string;
  needsInput: boolean;
  activeFor?: string[];
}

export const FILTER_OPERATOR_META: EntityFilterOperatorMeta[] = [
  {
    value: "ilike",
    needsInput: true,
    activeFor: ["STRING", "TEXT", "RICHTEXT", "LONGTEXT", "JSON"],
  },
  {
    value: "notiLike",
    needsInput: true,
    activeFor: ["STRING", "TEXT", "RICHTEXT", "LONGTEXT", "JSON"],
  },
  {
    value: "equal",
    needsInput: true,
    activeFor: ["STRING", "ID", "INT", "FLOAT", "TEXT", "RICHTEXT", "LONGTEXT", "JSON", "ENUM"],
  },
  {
    value: "notEqual",
    needsInput: true,
    activeFor: ["STRING", "ID", "INT", "FLOAT", "TEXT", "RICHTEXT", "LONGTEXT", "JSON", "ENUM"],
  },
  {
    value: "startsWith",
    needsInput: true,
    activeFor: ["STRING", "TEXT", "RICHTEXT", "LONGTEXT", "JSON"],
  },
  {
    value: "endsWith",
    needsInput: true,
    activeFor: ["STRING", "TEXT", "RICHTEXT", "LONGTEXT", "JSON"],
  },
  {
    value: "in",
    needsInput: true,
    activeFor: ["STRING", "ID", "INT", "FLOAT", "TEXT", "LONGTEXT", "ENUM"],
  },
  {
    value: "notIn",
    needsInput: true,
    activeFor: ["STRING", "ID", "INT", "FLOAT", "TEXT", "LONGTEXT", "ENUM"],
  },
  {
    value: "greaterThan",
    needsInput: true,
    activeFor: ["INT", "FLOAT", "DATETIME", "DATE", "TIME"],
  },
  {
    value: "lessThan",
    needsInput: true,
    activeFor: ["INT", "FLOAT", "DATETIME", "DATE", "TIME"],
  },
  {
    value: "greaterThanOrEqual",
    needsInput: true,
    activeFor: ["INT", "FLOAT", "DATETIME", "DATE", "TIME"],
  },
  {
    value: "lessThanOrEqual",
    needsInput: true,
    activeFor: ["INT", "FLOAT", "DATETIME", "DATE", "TIME"],
  },
  {
    value: "isEmpty",
    needsInput: false,
    activeFor: [
      "STRING",
      "TEXT",
      "RICHTEXT",
      "LONGTEXT",
      "ID",
      "INT",
      "FLOAT",
      "JSON",
      "ENUM",
      "DATETIME",
      "DATE",
      "TIME",
    ],
  },
  {
    value: "isNotEmpty",
    needsInput: false,
    activeFor: [
      "STRING",
      "TEXT",
      "RICHTEXT",
      "LONGTEXT",
      "ID",
      "INT",
      "FLOAT",
      "JSON",
      "ENUM",
      "DATETIME",
      "DATE",
      "TIME",
    ],
  },
  {
    value: "isTrue",
    needsInput: false,
    activeFor: ["BOOLEAN"],
  },
  {
    value: "isFalse",
    needsInput: false,
    activeFor: ["BOOLEAN"],
  },
  {
    value: "contains",
    needsInput: true,
    activeFor: ["JSON"],
  },
];
